import  gql  from 'graphql-tag'

export const clientTypes = gql`query clientTypes($isActive: Boolean){ 
    clientTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
